<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">上传excel</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <div>
              <el-button style="margin-bottom: 30px" type="primary" @click="save">导入</el-button>
            </div>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%">
              <el-table-column prop="id" label="ID" width="80" />
              <el-table-column prop="upload_at" label="会话日期" />
              <el-table-column prop="admin_name" label="创建人" />
              <el-table-column prop="created_at" label="上传时间" />
              <el-table-column prop="upload_status_text" label="状态" />
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.upload_status === 2" type="primary" @click="error(scope.row)">错误报告</el-button>
                  <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                    <p>确定删除吗?</p>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="del(scope.row)">确定</el-button>
                    </div>
                    <el-button v-if="scope.row.upload_status !== 0 && deleteShow === true" slot="reference" size="mini" type="danger">删除</el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

            <el-dialog title="错误报告" :visible.sync="errorShow" width="50%">
              <div class="error-report">
                <pre>{{ errorMsg }}</pre>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="closeError">关 闭</el-button>
              </span>
            </el-dialog>

            <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="'上传Execl'" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog';
import Pagination from '@/components/pagination/index';
import { getInspectionUpload, saveInspectionUploadPost, deleteInspectionUpload } from '@/api/vipQualityTest';

export default {
  components: {
    Pagination,
    Dialog,
  },
  data() {
    return {
      listLoading: false,
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      deleteShow: false,
      errorShow: false,
      errorMsg: '',
      dialogVisible: false,
      dialogModel: [
        {
          type: 'el-date-picker',
          label: '会话日期',
          prop: 'upload_at',
          dateType: 'date',
          format: 'yyyy-MM-dd',
        },
        {
          type: 'el-upload-file',
          label: '上传文件',
          prop: 'excel_file',
          action: '',
        },
      ],
    };
  },
  created() {
    this.getList(this.listQuery);
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await getInspectionUpload(Object.assign(this.listQuery, query));
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.deleteShow = data.data.delete_button;
      this.listLoading = false;
    },
    async save() {
      this.dialogVisible = true;
    },
    error(row) {
      this.errorMsg = row.error_report;
      this.errorShow = true;
    },
    async del(row) {
      const { data } = await deleteInspectionUpload({ id: row.id });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('删除成功');
      this.getList(this.listQuery);
    },
    closeError() {
      this.errorMsg = '';
      this.errorShow = false;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 弹窗确认
    async dialogSure(form) {
      const formData = new FormData();
      formData.append('excel_file', form.excel_file);
      formData.append('upload_at', form.upload_at);
      const { data } = await saveInspectionUploadPost(formData);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('上传成功');
      this.closeDialog();
      this.getList(this.listQuery);
    },
  },
};
</script>

<style>
.error-report {
  width: 100%;
  height: 400px;
  overflow-y: auto;
  /* background-color: pink; */
}
</style>